import React, { Fragment, useState } from "react"
import { Helmet } from "react-helmet"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { Button, Empty, Spin } from "antd"

import ReportAdmin from "./containers/ReportAdmin"
import {
  makeSelectLoadingMeditions,
  makeSelectMeditions,
} from "../Reports/containers/ReportHeaderV2/selectors"
import ReportAmbassador from "./containers/ReportAmbassador"
import ReportHeaderV2 from "../Reports/containers/ReportHeaderV2"
import "../Reports/index.less"

import {
  isModuleBySlug,
  LOCAL_ACTIVE_ROL,
} from "../utils/storage"
import {
  ROLE_AMBASSADOR,
  OVERALL_RESULTS,
  TYPE_SURVEY,
} from "../utils/constants"
import { validate } from "../utils/functions"
import { loadTexts } from "../utils/i18n"

export function ReportsV2Component(props) {
  const intl = loadTexts("reports_general_view")
  const [currentMeasure, setCurrentMeasure] = useState({})
  const [measureGeneralSelected, setMeasureGeneralSelected] = useState({})

  const { history, match } = props
  const isOverallResults = isModuleBySlug(OVERALL_RESULTS)

  const canRender =
    isOverallResults &&
    match.params.id_measure !== undefined &&
    parseInt(match.params.id_measure) === currentMeasure.id_measure

  let divisionID = null
  let segmentID = null
  let parentDivisionID = null

  if (canRender) {
    const searchLocation = getUrlParams(history.location.search)
    if (validate.exist(searchLocation)) {
      if (validate.exist(searchLocation.id_division)) {
        divisionID = parseInt(searchLocation.id_division)
      }
      if (validate.exist(searchLocation.id_segment)) {
        segmentID = parseInt(searchLocation.id_segment)
      }
      if (
        validate.exist(searchLocation.id_divisionParent) &&
        searchLocation.id_divisionParent !== "undefined"
      ) {
        parentDivisionID = parseInt(searchLocation.id_divisionParent)
      }
    }
  }

  const renderContent = () => {
    if (!canRender) {
      if (!isOverallResults || match.params.id_measure === undefined) return null
      // Antes quedaba en blanco para siempre si el listado fallaba o la medición de la URL
      // no estaba en el listado (filtro de estado o de rol)
      const isMeasureInList = (props.meditions || []).some(
        (medition) => medition.id_measure === parseInt(match.params.id_measure)
      )
      if (props.loadingMeditions || isMeasureInList) {
        return (
          <div className="loadingSpin">
            <Spin />
          </div>
        )
      }
      return (
        <Empty description={intl.measureNotAvailable}>
          <Button onClick={() => history.push("/reports")}>
            {intl.backToReports}
          </Button>
        </Empty>
      )
    }

    if (
      currentMeasure.id_survey_type === TYPE_SURVEY.leadership.idSurveyType
    ) {
      return (
        <ReportAdmin
          divisionID={divisionID}
          segmentID={segmentID}
          parentDivisionID={parentDivisionID}
          history={history}
          idMeasure={parseInt(match.params.id_measure)}
          currentMeasure={currentMeasure}
          onMeasureGeneralSelected={setMeasureGeneralSelected}
        />
      )
    }
    if (LOCAL_ACTIVE_ROL() === ROLE_AMBASSADOR.toString()) {
      return (
        <ReportAmbassador
          divisionID={divisionID}
          segmentID={segmentID}
          parentDivisionID={parentDivisionID}
          history={history}
          idMeasure={parseInt(match.params.id_measure)}
          currentMeasure={currentMeasure}
          onMeasureGeneralSelected={setMeasureGeneralSelected}
        />
      )
    }
    return (
      <ReportAdmin
        divisionID={divisionID}
        segmentID={segmentID}
        parentDivisionID={parentDivisionID}
        history={history}
        idMeasure={parseInt(match.params.id_measure)}
        currentMeasure={currentMeasure}
        onMeasureGeneralSelected={setMeasureGeneralSelected}
      />
    )
  }

  return (
    <Fragment>
      <Helmet>
        <title>{intl.titlePage}</title>
        <meta name="description" content="Reportes" />
      </Helmet>
      <div className="container-report">
        <ReportHeaderV2
          isHome
          match={match}
          visibleHeader
          idMeasure={
            match.params.id_measure !== undefined
              ? parseInt(match.params.id_measure)
              : null
          }
          idSurveyType={
            match.params.id_survey_type !== undefined
              ? parseInt(match.params.id_survey_type)
              : null
          }
          history={history}
          setCurrentMeasure={setCurrentMeasure}
          measureGeneralSelected={measureGeneralSelected}
        />
        {renderContent()}
      </div>
    </Fragment>
  )
}

const mapStateToProps = createStructuredSelector({
  loadingMeditions: makeSelectLoadingMeditions(),
  meditions: makeSelectMeditions(),
})

export const ReportsV2 = connect(mapStateToProps)(ReportsV2Component)

export default ReportsV2
